import { t } from '../../i18n/pt';
import styles from './Badge.module.scss';

type BadgeVariant = 'new' | 'out';

interface Props {
  variant: BadgeVariant;
  className?: string;
}

export function Badge({ variant, className }: Props): JSX.Element {
  const label = variant === 'new' ? t.products.badgeNew : t.products.badgeOut;
  return (
    <span
      className={[styles.badge, styles[variant], className ?? ''].filter(Boolean).join(' ')}
    >
      {label}
    </span>
  );
}
